/*
 * @Author: zhoujialei
 * @Date: 2019-07-10 09:33:50
 * @LastEditors: zhoujialei
 * @LastEditTime: 2020-07-16 16:01:03
 * @Description: file content
 */
import Fetch, { pageInfo } from './fetch';

const userRequests = {

    //退出登录
    logout() {
        return Fetch({
            url: '/logout',
            method: 'post'
        });
    },
    getUserInfoByIdHeaders(sysCode, schoolId) {
        return Fetch({
            url: '/ucAccount/getUserInfoById?schoolId=' + schoolId,
            method: 'get',
            headers: {
                sysCode
            }
        });
    }

}

export default userRequests;



// WEBPACK FOOTER //
// ./src/api/user.js